function isNotNil<T>(value: T): value is NonNullable<T> {
  return value !== undefined && value !== null;
}

export default isNotNil;
